import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'PaymentTypePipe'
})
export class PaymentTypePipe implements PipeTransform {

  private listObj = {
    0: 'Credit Card',
    1: 'Fawry',
  };

  transform(value: number): string {
    console.log("transforming: ", value)
    return this.listObj.hasOwnProperty(value) ? this.listObj[value] : '';
  }

}
